function n(n){setTimeout(n,1)}var r=function(n,r){var t={};return t[n]=r,t},t=function(n){return n&&"current"in n?n.current:n};export{n as deferAction,t as extractRef,r as inlineProp};
//# sourceMappingURL=util.js.map
